import { mascaraTelefone, numberToReal, isDate, onlyDate, convertArmazenamento, mascaraCNPJ, verificaStringNull, mascaraCpfOuCnpj } from '@/service/util'

import { format, register } from 'timeago.js'

const localeFunc = (number, index) => {
  return [
    ['agora mesmo', 'daqui um pouco'],
    ['há %s segundos', 'em %s segundos'],
    ['há um minuto', 'em um minuto'],
    ['há %s minutos', 'em %s minutos'],
    ['há uma hora', 'em uma hora'],
    ['há %s horas', 'em %s horas'],
    ['há um dia', 'em um dia'],
    ['há %s dias', 'em %s dias'],
    ['há uma semana', 'em uma semana'],
    ['há %s semanas', 'em %s semanas'],
    ['há um mês', 'em um mês'],
    ['há %s meses', 'em %s meses'],
    ['há um ano', 'em um ano'],
    ['há %s anos', 'em %s anos']
  ][index]
}
// register your locale with timeago
register('br', localeFunc)

function capitalize (value) {
  if (!value) return ''
  let array = value.toString().toLocaleLowerCase().split(' ')
  array = array.map(e => e.charAt(0).toUpperCase() + e.slice(1))
  return array.join(' ')
}

// main.js ou similar
function filterNulls (value) {
  if (!value) return '{}'

  const filter = (obj) => {
    if (obj === null || obj === undefined) return undefined

    if (Array.isArray(obj)) {
      return obj.map(item => filter(item)).filter(item => item !== undefined)
    }

    if (typeof obj === 'object') {
      const result = {}
      Object.keys(obj).forEach(key => {
        const filtered = filter(obj[key])
        if (filtered !== undefined) {
          result[key] = filtered
        }
      })
      return Object.keys(result).length ? result : undefined
    }

    return obj
  }

  try {
    const parsed = typeof value === 'string' ? JSON.parse(value) : value
    return JSON.stringify(filter(parsed), null, 2)
  } catch (e) {
    console.error('Filter error:', e)
    return '{}'
  }
}

export default {
  capitalize,
  formatCpf: function (text) {
    const badchars = /[^\d]/g
    const mask = /(\d{3})(\d{3})(\d{3})(\d{2})/
    const cpf = text.replace(badchars, '')
    return cpf.replace(mask, '$1.$2.$3-$4')
  },
  first: function (value) {
    if (!value) return ''
    const array = value.split(' ')
    return array[0] || ''
  },
  last: function (value) {
    if (!value) return ''
    const array = value.split(' ')
    const lastPos = array.length
    return array[lastPos - 1] || ''
  },
  removeConsig: function (value) {
    if (!value) return ''
    const array = value.split(' ')
    if (array[0].toLowerCase() === 'consignado') delete array[0]
    if (array[1].toLowerCase() === 'inss') delete array[1]
    return array.join(' ') || ''
  },
  active: function (value) {
    return value ? 'SIM' : 'NÃO'
  },
  numberToReal,
  telefone: function (valor) {
    return mascaraTelefone(valor)
  },
  diasData: function (date) {
    let dt1 = new Date(date)
    let dt2 = new Date()
    return Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) / (1000 * 60 * 60 * 24))
  },
  idade (date) {
    date = isDate(onlyDate(date))
    let d = new Date()
    let ano = d.getFullYear()
    let mes = d.getMonth() + 1
    let dia = d.getDate()
    let anoDate = date.getFullYear()
    let diaDate = date.getDate()
    let mesDate = date.getMonth() + 1
    let anos = ano - anoDate
    if (mesDate > mes || (mesDate === mes && diaDate > dia)) anos--
    return anos < 0 ? 0 : anos
  },
  percRent (liberado, comissao) {
    if (liberado && comissao) {
      let rent = (comissao / liberado) * 100
      rent = numberToReal(rent) + '%'
      return rent
    } else if (comissao) return '100%'
    return '0%'
  },
  qntoTempo (date) {
    return format(date, 'br')
  },
  convertArmazenamento,
  splitCaracter: (value, separator = '_', subsitute = ' ') => value ? value.replaceAll(separator, subsitute) : '',
  enumToString: (value) => value ? capitalize(value.replaceAll('_', ' ')) : '',
  CPF: (cpf = '') => cpf ? cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4') : '',
  mascaraCNPJ,
  mascaraCpfOuCnpj,
  mesAnoPTBR (data) {
    let meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']
    data = new Date(data)
    return meses[data.getMonth()] + '/' + data.getFullYear()
  },
  verificaStringNull,
  formataMilharK: function (valor) {
    if (!valor) return numberToReal(0)
    if (valor < 1000) return numberToReal(valor)
    else {
      let valorRetornar = (valor / 1000).toFixed(1)
      valorRetornar = valorRetornar.split('.')
      valorRetornar[0] = valorRetornar[0].split(/(?=(?:...)*$)/).join('.')
      valorRetornar[0] = valorRetornar[0].replace('-.', '-')
      if (valorRetornar[1] === '0') return valorRetornar[0] + 'K'
      return valorRetornar.join(',') + 'K'
    }
  },
  filterNulls
}



// WEBPACK FOOTER //
// ./src/filter/index.js